import React, { Component } from 'react'
import { matchPath, Redirect } from 'react-router-dom'
import classNames from 'classnames'
import * as storage from '../../storage'

import { SearchIcon } from '../SVGIcons'
import Form from '../Form/Form'

import './LBUSearchBox.css'

class LBUSearchBox extends Component {

  state = {
    query: storage.get('query') || '',
		formSubmitted: false,
    searchAtMountTime: false,
		formActive: false
  }

  componentDidMount() {
    const query = this.getQuery(this.props.location.pathname) || this.state.query
    if (query) {
      this.setState({ query, searchAtMountTime: true })
    }
	}

  componentDidUpdate(prevProps, prevState) {
		if (this.props.location !== prevProps.location) {
      const query = this.getQuery(this.props.location.pathname)
      if (query) {
        this.setState({ query })
      }
		}
    if (prevState.query !== this.state.query) {
      storage.set('query', this.state.query)
    }
		if (this.state.formSubmitted) {
			this.setState({ formSubmitted: false })
		}
    if (this.state.searchAtMountTime) {
			this.setState({ searchAtMountTime: false })
		}
	}

  /**
   * Returns the parsed query parameter from given location pathname
   */
  getQuery = (pathname) => {
    const match = matchPath(pathname, {
      path: '/lbus/query/:query',
      exact: false,
      strict: false
    })
    if (match) {
      return decodeURIComponent(match.params.query)
    }
    return
  }

  onFocus = (e) => {
    if (e.target && e.target === this.searchInput) {
      this.setState({ formActive: true })
    }
  }

  onBlur = (e) => {
    this.doBlur()
  }

  doBlur = () => {
    this.searchInput.blur()
    this.setState({ formActive: false })
  }

  onSearchButtonClicked = (e) => {
		e.preventDefault()
		if (this.state.query) {
			this.doSubmit()
		} else {
			this.searchInput.focus()
		}
	}

  onSubmit = (e) => {
		this.doSubmit()
	}

	doSubmit = () => {
		this.doBlur()
		this.setState({ formSubmitted: true })
	}

  getSearchUrl = (query) => {
		let url = ['/lbus']
		if (query) {
			url.push('query')
			url.push(encodeURIComponent(query))
		}
		return url.join('/')
	}

  render() {

    const { formSubmitted, searchAtMountTime, query, formActive } = this.state

    return (
      <div className={classNames("LBUSearchBox", { formActive: formActive })}>
        {formSubmitted && (
          <Redirect to={this.getSearchUrl(query)} push={true} />
        )}
        {searchAtMountTime && (
          <Redirect to={this.getSearchUrl(query)} push={false} />
        )}
        <Form onSubmit={this.onSubmit}>
            <button className="searchButton" onClick={this.onSearchButtonClicked}>
              <SearchIcon />
            </button>
            <input
                type="search"
                placeholder="Search LBU"
                value={query}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
                onChange={e => {
                  this.setState({query: e.target.value})
                }}
                autoComplete="off"
            autoCorrect="off"
            autoCapitalize="off"
            spellCheck="false"
            ref={(elem) => { this.searchInput = elem }} />
        </Form>
      </div>
    )
  }

}

export default LBUSearchBox



// WEBPACK FOOTER //
// ./src/components/LBUSearchBox/LBUSearchBox.js